// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const well = defineModel({
  id: "well",
  batchId: "future",
  name: "Well",
  tags: ["building","well","low-poly","age-of-mcp","future","water"],
  summary: "Draws water — needed by people, animals and many crafts.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.5,
  defaultVariant: "complete",
  variants: [
    { id: "stage-0", label: "Foundation", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
    ] },
    { id: "stage-1", label: "Lower", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.32, 0.34, 12), color: "#9a948a", position: [0, 0.31, 0] },
      { geometry: new THREE.CylinderGeometry(0.33, 0.33, 0.06, 12), color: "#7c766c", position: [0, 0.5, 0] },
      { geometry: new THREE.CylinderGeometry(0.25, 0.25, 0.02, 12), color: "#3b6b86", position: [0, 0.42, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [-0.35, 0.25, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [0.35, 0.25, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [-0.35, 0.25, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.5, 4), color: "#6b4a26", position: [0.35, 0.25, 0.35] },
    ] },
    { id: "stage-2", label: "Upper", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.32, 0.34, 12), color: "#9a948a", position: [0, 0.31, 0] },
      { geometry: new THREE.CylinderGeometry(0.33, 0.33, 0.06, 12), color: "#7c766c", position: [0, 0.5, 0] },
      { geometry: new THREE.CylinderGeometry(0.25, 0.25, 0.02, 12), color: "#3b6b86", position: [0, 0.42, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.5, 0.06), color: "#6e4f2e", position: [-0.3, 0.78, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.5, 0.06), color: "#6e4f2e", position: [0.3, 0.78, 0] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.35, 0.425, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.35, 0.425, -0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [-0.35, 0.425, 0.35] },
      { geometry: new THREE.CylinderGeometry(0.025, 0.025, 0.85, 4), color: "#6b4a26", position: [0.35, 0.425, 0.35] },
    ] },
    { id: "complete", label: "Complete", parts: () => [
      { geometry: new THREE.BoxGeometry(0.86, 0.14, 0.86), color: "#5a5a5a", position: [0, 0.07, 0] },
      { geometry: new THREE.CylinderGeometry(0.3, 0.32, 0.34, 12), color: "#9a948a", position: [0, 0.31, 0] },
      { geometry: new THREE.CylinderGeometry(0.33, 0.33, 0.06, 12), color: "#7c766c", position: [0, 0.5, 0] },
      { geometry: new THREE.CylinderGeometry(0.25, 0.25, 0.02, 12), color: "#3b6b86", position: [0, 0.42, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.5, 0.06), color: "#6e4f2e", position: [-0.3, 0.78, 0] },
      { geometry: new THREE.BoxGeometry(0.06, 0.5, 0.06), color: "#6e4f2e", position: [0.3, 0.78, 0] },
      { geometry: new THREE.BoxGeometry(0.447214, 0.05, 0.6), color: "#7a4a2c", position: [0.2, 1.13, 0], rotation: [0, 0, -0.463648] },
      { geometry: new THREE.BoxGeometry(0.447214, 0.05, 0.6), color: "#7a4a2c", position: [-0.2, 1.13, 0], rotation: [0, 0, 0.463648] },
      { geometry: new THREE.BoxGeometry(0.06, 0.06, 0.62), color: "#563d22", position: [0, 1.23, 0] },
      { geometry: new THREE.CylinderGeometry(0.05, 0.05, 0.5, 8), color: "#6e4f2e", position: [0, 0.71, 0], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.04, 0.12, 0.04), color: "#563d22", position: [0.28, 0.77, 0] },
      { geometry: new THREE.BoxGeometry(0.1, 0.03, 0.03), color: "#563d22", position: [0.31, 0.83, 0] },
      { geometry: new THREE.CylinderGeometry(0.01, 0.01, 0.22, 4), color: "#b9a574", position: [0, 0.6, 0], name: "bucket" },
      { geometry: new THREE.CylinderGeometry(0.07, 0.06, 0.12, 8), color: "#5a4128", position: [0, 0.43, 0], name: "bucket" },
      { geometry: new THREE.TorusGeometry(0.06, 0.012, 4, 8), color: "#b9a574", position: [0, 0.5, 0], rotation: [1.570796, 0, 0], name: "bucket" },
    ] },
  ],
  animations: [],
  // Where a worker stands to draw water: just outside the rim on the +Z (front)
  // side, turned to face the shaft. (The worker is modelled facing +Z, so the
  // half-turn points its forward at the well.)
  stations: [
    { id: "front", position: [0, 0, 0.6], facing: Math.PI, description: "Where a worker stands to draw water." },
  ],
  // The headline INTERACTION (vs. a plain animation): a two-body motion. The
  // worker (the actor, supplied by the consumer) is posed at the station while
  // the well's own bucket rises — coupling actor and model. Only meaningful on
  // the finished well, where the windlass and bucket exist.
  interactions: [
    {
      id: "draw-water",
      label: "Draw water",
      duration: 3,
      loop: true,
      station: "front",
      variants: ["complete"],
      tracks: [
        // Self: the bucket climbs the shaft and back down, about the windlass.
        {
          subject: "self",
          target: "bucket",
          pivot: [0, 0.71, 0],
          position: [
            { t: 0, value: [0, 0, 0] },
            { t: 1.5, value: [0, 0.22, 0], ease: "sine" },
            { t: 3, value: [0, 0, 0], ease: "sine" },
          ],
        },
        // Actor: bow the whole worker over the rim, then straighten as the bucket
        // comes up (the effort), pivoting about the feet.
        {
          subject: "actor",
          target: "root",
          rotation: [
            { t: 0, value: [0.5, 0, 0], ease: "sine" },
            { t: 1.5, value: [0.12, 0, 0], ease: "sine" },
            { t: 3, value: [0.5, 0, 0], ease: "sine" },
          ],
        },
        // Actor: crank the right arm round the shoulder, one turn per cycle.
        {
          subject: "actor",
          target: "arm-r",
          pivot: [0.115, 0.34, 0],
          rotation: [
            { t: 0, value: [0, 0, 0] },
            { t: 3, value: [-Math.PI * 2, 0, 0] },
          ],
        },
      ],
    },
  ],
});
